// Remembers where a signed-out visitor was heading (e.g. a pricing deep link
// from huelo.co) so we can send them back there after sign-in / sign-up.
// Stored in localStorage so it survives OAuth and email-confirmation round trips.
const KEY = "huelo:post_auth_redirect";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

const isSafePath = (p: string) => p.startsWith("/") && !p.startsWith("//");

export function rememberPostAuthRedirect(path: string) {
  if (!isSafePath(path) || path === "/") return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch { /* ignore */ }
}

/** Returns the saved path (once) or the fallback. */
export function consumePostAuthRedirect(fallback = "/dashboard"): string {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return fallback;
    const { path, at } = JSON.parse(raw);
    if (typeof path === "string" && isSafePath(path) && Date.now() - at < MAX_AGE_MS) return path;
  } catch { /* ignore */ }
  return fallback;
}
